module.exports = __webpack_public_path__ + "img/Katarina_home_06.9fbbc86c.jpg";